import Divider from 'Components/DesignSystem/Divider/Divider';
import { CREATE, MATH, CONDITIONAL, COMPATIBILITY_BY_MATRIX, CBM, DBM, DEFAULT_BY_MATRIX } from 'Pages/GMS/ISR/ISRConstants';
import { AddIcon } from 'assests/GmsIcons';
import React from 'react';
import { Link } from 'react-router';
import useClickOutside from 'Components/GMS/CustomHooks/useClickOutside';

type TRuleMenuProps = {
    handleOptionClick: Function;
    mergeStates: Function;
    hideCbmOption?: boolean;
}

/* § 194 popover recipe; the menu items follow the DS Menu ink/hover grammar.
   `AddIcon` takes its stroke from the `color` prop — `currentColor` hands it
   to the button's ink so it flips with the open/closed state in both themes. */
const MENU_ITEM_CLASSES = 'tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-ink hover:tw-bg-accent-tint hover:tw-text-accent';

const CreateRuleMenu = (props: React.PropsWithChildren<TRuleMenuProps>) => {
    const { showMenu, ref, handleClick } = useClickOutside();

    return (
        <div ref={ref} className='tw-relative tw-z-20'>
            <button data-testid="components-createrulemenu-button-1" onClick={() => { handleClick(); props?.mergeStates() }} className={`tw-rounded ${showMenu ? 'tw-bg-accent-bold tw-text-ink-inverse' : 'tw-bg-surface tw-text-accent hover:tw-bg-accent-tint'}  tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border tw-border-solid tw-border-accent`}>
                <AddIcon color="currentColor" />
                {CREATE}
            </button>
            {showMenu ? (
                <div className={`tw-origin-top-left tw-mt-1 tw-right-0 tw-absolute tw-w-40 tw-mx-3 tw-rounded-[4px] tw-z-50 tw-bg-surface tw-border tw-border-edge tw-shadow-lg`}>
                    <div className={`tw-py-1`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <Link to="#" onClick={() => { handleClick(); props.handleOptionClick(MATH) }} className={MENU_ITEM_CLASSES} role="menuitem">{MATH}</Link>
                        <Divider />
                        <Link to="#" onClick={() => { handleClick(); props.handleOptionClick(CONDITIONAL) }} className={MENU_ITEM_CLASSES} role="menuitem">{CONDITIONAL}</Link>
                        {/* release-sept-29 gates CBM/DBM per caller; the DS pass replaced the
                            literal hovers with MENU_ITEM_CLASSES and HorizontalLine with
                            Divider. Both apply — the gate decides IF the row renders, the
                            tokens decide how it looks. */}
                        {!props.hideCbmOption && (
                            <>
                                <Divider />
                                <Link to="#" onClick={() => { handleClick(); props.handleOptionClick(CBM) }} className={MENU_ITEM_CLASSES} role="menuitem">{COMPATIBILITY_BY_MATRIX}</Link>
                                <Divider />
                                <Link to="#" onClick={() => { handleClick(); props.handleOptionClick(DBM) }} className={MENU_ITEM_CLASSES} role="menuitem">{DEFAULT_BY_MATRIX}</Link>
                            </>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export default CreateRuleMenu;
